import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";

import swal from "sweetalert2";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { Combo2Service } from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
import { PrintData } from "../../master/print/print";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
import * as XLSX from 'xlsx';
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { RowPlaceholder } from "@angular/cdk/table";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./purchaseOrder.html",
})
export class PurchaseOrderComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    party_code: "",
    po_no: "",
    order_from_date: "",
    order_to_date: "",
    finyear: "2021-2022",
    XL_party : ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild('table') table: ElementRef;
  // @ViewChild("excelTemplate") excelTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  filteredOptions: Observable<string[]>;

  parentCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  codeList: any;
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  XLdata : any = [];
  printData;
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
      private modalService: BsModalService,
  
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService
  ) {}

  ngOnInit(): void {
    this.finyearCombo();
    this.getColumns();
    this.codelist();

    this.toggleCol = Object.assign({}, this.columns);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.codeList.filter((option) =>
      option.code.toLowerCase().includes(filterValue)
    );
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "PO No",
        prop: "po_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        toggle: true,
      },
      {
        name: "PO Date",
        prop: "po_date_formatted",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Party Code",
        prop: "party_code",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "Indent No",
        prop: "indent_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Total Mtrs",
        prop: "totalmtr",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Total Value",
        prop: "total_amount",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "No of Designs",
        prop: "no_of_design",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 180,
        maxWidth: 180,
        width: 180,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.codeList = res.data;
      this.filteredOptions = this.parentCtrl.valueChanges.pipe(
        startWith(""),
        map((value) => this._filter(value))
      );
    });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party_code = "";
    this.filter.po_no = "";
    this.filter.order_from_date = "";
    this.filter.order_to_date = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getOrderList();
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      //   var temp = ["Core", "All"];
      //   that.finyearList.concat(temp);
      //    that.finyearCtrl.setValue(res.data[0].fin_id);
       that.filter.finyear = res.data[0].finyear;
    });
  }

  bsModalRef: BsModalRef;
  printInvoice(row) {
    let params = {
      printType: "purchase",
      party_id: row.party_id,
      po_id: row.po_id
    };
    this.poservice.purchaseOrderlistPrint(params).then((res: any) => {
      this.printData = res;

      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-60",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printcontent = this.printData;
    });
  }
  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  addEditPO(mode: string, row: any): void {
    this.filterExpand = true;
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.filterExpand = true;
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD PURCHASE ORDER",
          title: "ADD PURCHASE ORDER",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "ADD PURCHASE ORDER",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT PURCHASE ORDER",
          title: "EDIT PURCHASE ORDER",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "EDIT PURCHASE ORDER",
        },
      };
    } else if (mode == "View") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW PURCHASE ORDER",
          title: "VIEW PURCHASE ORDER",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "VIEW PURCHASE ORDER",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  getOrderList(): void {
    if (this.filter.order_from_date == "") {
      this.filter.order_from_date == "";
    } else {
      this.filter.order_from_date = this.datePipe.transform(
        this.filter.order_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.order_to_date == "") {
      this.filter.order_to_date == "";
    } else {
      this.filter.order_to_date = this.datePipe.transform(
        this.filter.order_to_date,
        "yyyy-MM-dd"
      );
    }

    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      party_code: this.filter.party_code,
      po_no: this.filter.po_no,
      order_from_date: this.filter.order_from_date,
      order_to_date: this.filter.order_to_date,
      finyear: this.filter.finyear,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.poservice
      .getOrderList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }
  getXLPo(row : any): void{
    this.XLdata = [];
    this.filter.XL_party = "";
   let params ={
     po_id : row.po_id
   }
   let that = this;
   this.isLoadMask = this.poservice
     .getPoXlDetails(params)
     .then(function (res: any) {
       that.loadingIndicator = false;
      //  that.page.count = res.totCnt;

       that.XLdata = res.data;
       that.filter.XL_party = res.data[0].party_code;
  
       setTimeout(() => {
        that.ConvertToXL()
       }, 4000);
     });
  }
  ConvertToXL(){
    console.log(this.table.nativeElement)
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'PoSheet.xlsx');
  }
  deleteOrder(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Order Details?",
      text:
        "You will not be able to recover this Order" + " " + row["po_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.poservice
          .deleteOrder(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getOrderList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/purchaseOrder/purchaseOrder.ts